import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {
    IMyCompanyBank
} from "../../../../../../../utils/interfaces/my_company/my_company_registry/my_company_bank/IMyCompanyBank";


const useApiGetMyCompanyBank = (pk: number | undefined): UseQueryResult<IMyCompanyBank, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined, pk: number | undefined): Promise<IMyCompanyBank> {
        try {
            const response = await get(`/api/company/${company_token}/my_company/my_company_registry/bank/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetMyCompanyBank", pk],
        queryFn: () => doGet(selectedCompany?.company_token, pk),
        enabled: !!pk,
    })

};

export default useApiGetMyCompanyBank